import React from 'react';

export function PendingDot() {
  return <div className="my-auto h-4 w-4 rounded-full bg-orange-300"></div>;
}
